import React, {Component} from "react";
//import  {
import {
    View,
    FlatList,
    ActivityIndicator, Platform, KeyboardAvoidingView, TouchableOpacity, Alert, BackHandler, ScrollView, Image
} from "react-native";
import styles from "../../../../styles/DetialsAdversingMainStyles";
import EmptyView from "../../../../customviews/empty/EmptyView";
import Colors from "../../../../tools/Colors";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import i18n from "../../../../I18n/i18n";
import {typeExport} from "../../../../redux/store/type";
import store from "../../../../redux/store";
import {
    serviceActionAddSubList,
    serviceActionListFilter,
    serviceActionSuccess,
    serviceActionError
} from "./action/ActionListQuestionAndAnswerSatiaScreen";
import {moderateScale} from "../../../../tools/Scaling";
import HMTextView from "../../../../customviews/HMTextView";

import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";

import FontAwesomeIcon from 'react-native-vector-icons/dist/FontAwesome';
import HMActionBarSatia from "../../../../customviews/HMActionBarSatia";
import HMIcon from "./../../../../customviews/HMIcon";
import HMButton from "../../../../customviews/HMButton";
import HMTextInput from "../../../../customviews/HMTextInput";
import PathFile from "../../../../assets/PathFile";
import HMModal from "../../../../customviews/modal/HMModal";
import HMTextInputEfects from "../../../../customviews/HMTextInputEfects";

let container = null;
export default class ListQuestionAndAnswerSatiaScreen extends Component {
    constructor(props) {
        super(props);
        let myLocation = store.getState().reducerSplashSatiaScreen.Location;
        let lat = 0
        let long = 0
        if (!myLocation) {
            lat = parseFloat(myLocation ? myLocation.coords.latitude : 0);
            long = parseFloat(myLocation ? myLocation.coords.longitude : 0);
            // long = parseFloat(props.navigation && props.route.params ? props.route.params.position.coords.longitude : props.position ? props.position.coords.longitude : 0);

        }
        this.state = {
            //  indexSelectParent:0,
            token: "359601088562055",
            checkPushResultOffline: false,
            textMenu: "پیام های ارسال شده",
            indexMenu: 0,
            visibleModal: false,
            indexFilter: 0,

            lat: lat,
            long: long,
            dataSourcearrayCondition: [{name: 'ثبت شد', id: 1}, {
                name: 'در دست اقدام',
                id: 2
            }, {name: 'تکراری در دست اقدام', id: 3}, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {
                name: 'تایید واحد',
                id: 5
            },],
            textCondition: null,
            arrayCondition: [{name: 'ثبت شد', id: 1}, {name: 'در دست اقدام', id: 2}, {
                name: 'تکراری در دست اقدام',
                id: 3
            }, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {name: 'تایید واحد', id: 5},],
            Condition: {id: 0, value: "وضعیت پیام"},

            arrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            textOperational_Unit: null,
            dataSourcearrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            Operational_Unit: {id: 0, value: "واحد اجرایی"},

            arraySelected: [],
            trackingCode: null

        };
        container = this;

        store.dispatch(serviceActionListFilter([]))
        this.props.callserviceActionRefresh();
        this.getData(1)
        this.props.navigation.addListener('focus', () => {
                /*   store.dispatch(serviceActionListFilter([]))
                   props.callserviceActionRefresh();
                   this.getData(1)*/
            }
        )
        this.props.navigation.addListener('blur', () => {}
        )

    }

    state = {
        show: false
    };

    componentWillReceiveProps(propss) {

    }

    async componentDidMount() {

    }

    componentWillUnmount() {

    }

    async getData(page) {
        //  let {item, data} = this.props.route.params
        container.setState({
            visibleModal: false
        })
        let after = "0000-00-00";
        //   this.props.callService(urlListQuestionAndAnswerSatiaScreen, `?type=${this.props.typee}&Condition=`, TypeGetListQuestionAndAnswerSatiaScreen, 'POST',page,this.props.item_count)
        // this.props.callService(typeExport.urlListQuestionAndAnswerSatiaScreen, `?lang=${i18n.locale}&token=${this.props.DataSplashScreen.token}`, typeExport.TypeGetListQuestionAndAnswerSatiaScreen, 'POST', page, 10)
        /*  let paramss = {
              "id": 1,
              "lang": i18n.locale,
              "imei": 0,
              "page": page,
               "after": "0000-00-00"
          };
          this.props.callService(this.props.route.params.item.link_url, paramss, typeExport.TypeGetListQuestionAndAnswerSatiaScreen, _GET, page, 10)
  */

        let paramss = {
            "serialTicket": container.props.route.params.item.Serial,
            "lang": i18n.locale,
            "_session": store.getState().reducerSplashSatiaScreen.token,
            "page": page,

        };
        if (store.getState().reducerSplashSatiaScreen.Connection) {

            container.props.callService(typeExport._baseUrlSatia + "support/getResponses", paramss, typeExport.TypeGetListQuestionAndAnswerSatiaScreen, typeExport._POST, page, typeExport._Count, null)

        } else {
            // let data = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListServiceHistorySatia + item.type)
            // let listFilter = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListServiceHistorySatiaFilter + item.type)
            // store.dispatch(serviceActionListFilter(listFilter))
            // if (data != null)
            //     store.dispatch(serviceActionSuccess(data, 0))
            // else
            //     store.dispatch(serviceActionSuccess([], 0))

            store.dispatch(serviceActionError('not connection', 1))
        }

    }

    _menu = null;

    setMenuRef = ref => {
        this._menu = ref;
    };
    hideMenu = (item, key) => {
        this.setState({
            textMenu: item.title,
            indexMenu: key
        })
        this._menu.hide();
    };

    showMenu = () => {
        this._menu.show();
    };

    _onMapReady = () => this.setState({marginBottom: 0})

    render() {
        let {item} = this.props.route.params
        let myLocation = store.getState().reducerSplashSatiaScreen.Location;
        let {user, token} = this.props.DataSplashSatiaScreen;

        // let {result} = store.getState().reducerSplashSatiaScreen.resultsShahrdar

        // let childFilter = result.items[this.state.indexFilter].list;
        //let childFilter = this.props.ListFilter && this.props.ListFilter.length > 0 ? this.props.ListFilter[this.state.indexFilter] : [];
        return (
            <View style={{position: 'relative', flex: 1,}}>


                {/*<HMImageBackground*/}

                {/*/>*/}

                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <HMActionBarSatia
                            menu
                            back

                            props={this.props} statusBarTransparent
                            // text={i18n.t('ListServiceHistorySatia.title')}
                            text={(item.name ? item.name : (item.title ? item.title : 'سوال و جواب'))}
                            //text={(data.name ? data.name : (data.title ? data.title : ''))}
                            //  text={this.state.arraySelected.length}


                            //  text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}

                        />

                        <View style={{flex: 1}}>


                            <EmptyView empty={this.props.empty}/>
                            <FlatList
                                data={this.props.results}
                                /*  data={[
                                      {
                                          id: 1,
                                          date: "1399/03/11",
                                          title: "سرعت اینترنت کم است",
                                          part: "محسن صالحی",
                                          desc: "سلام",
                                          type: 2,
                                      },
                                      {
                                          id: 1,
                                          date: "1399/03/12",
                                          title: "اینترنت قطع شده",
                                          part: "پشتيباني فني",
                                          desc: "سلام",
                                          type: 1,
                                      },
                                      {
                                          id: 1,
                                          date: "1399/03/11",
                                          title: "سرعت اینترنت کم است",
                                          part: "محسن صالحی",
                                          desc: "خوبی",
                                          type: 2,
                                      },
                                      {
                                          id: 1,
                                          date: "1399/03/10",
                                          title: "اینترنت قطع شده",
                                          part: "پشتيباني فني",
                                          priority: "بسیار بالا",
                                          desc: "ممنون تو خوبی",
                                          type: 1,
                                      },
                                      {
                                          id: 1,
                                          date: "1399/03/11",
                                          title: "سرعت اینترنت کم است",
                                          part: "محسن صالحی",
                                          desc: "فدات چه خبر",
                                          type: 2,
                                      },
                                      {
                                          id: 1,
                                          date: "1399/03/10",
                                          title: "اینترنت قطع شده",
                                          part: "پشتيباني فني",
                                          priority: "بسیار بالا",
                                          desc: "سلامتی",
                                          type: 1,
                                      },
                                  ]}*/
                                renderItem={({item, index}) => {
                                    return <View
                                        style={{
                                            flex: 1,
                                            overflow: 'hidden',
                                            //height:  moderateScale(100),
                                            // padding: moderateScale(4),
                                            margin: moderateScale(5),
                                            borderWidth: moderateScale(1),
                                            borderRadius: moderateScale(2),
                                            borderColor: '#ddd',
                                            borderBottomWidth: 0,
                                            shadowColor: '#000',
                                            shadowOffset: {width: 0, height: moderateScale(.7)},
                                            shadowOpacity: 0.6,
                                            shadowRadius: moderateScale(2),
                                            elevation: moderateScale(1),
                                            // marginLeft: moderateScale(1),
                                            // marginRight: moderateScale(1),
                                            // marginTop: moderateScale(1),
                                            // marginBottom: moderateScale(1),
                                            backgroundColor: item.type == 1 ? Colors.green1 : Colors.white,
                                            marginStart: item.type == 1 ? moderateScale(15) : moderateScale(3),
                                            marginEnd: item.type == 1 ? moderateScale(3) : moderateScale(15),
                                        }}>
                                        <View style={{
                                            width: '100%',
                                            //        backgroundColor: Colors.colorSecondPrimary,
                                            //  flexDirection: 'row',
                                            //   justifyContent: "center",
                                            padding: moderateScale(6)
                                        }}>

                                            <View
                                                style={{
                                                flexDirection: 'row',
                                                flex: 1,
                                                alignItems: 'center'

                                            }}>
                                                <Image
                                                    source={item.type == 1 ? (PathFile.image.call_center ): (user.image ? {uri: user.image} :(PathFile.image.user))}
                                                    //resizeMode="stretch"
                                                    style={[{}, {


                                                        //   margin: moderateScale(5),
                                                        width: moderateScale(35),
                                                        height: moderateScale(35),

                                                        tintColor: Colors.blackLight

                                                    }]}/>
                                                <View style={{marginHorizontal: moderateScale(6)}}>
                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={item.custname}
                                                        type={"bold"}
                                                        style={{
                                                            //  textAlign: "center",
                                                            color: Colors.blackLight,
                                                            fontSize: moderateScale(14),


                                                        }}/>
                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={item.ResDate}
                                                        //type={"bold"}
                                                        style={{
                                                            //  textAlign: "center",
                                                            color: Colors.colorDarkText,
                                                            fontSize: moderateScale(14),


                                                        }}/>
                                                </View>
                                                {/*<MaterialIcons name="support" style={{*/}
                                                {/*color: Colors.white,*/}
                                                {/*fontSize: moderateScale(28),*/}
                                                {/*//  padding: moderateScale(4),*/}
                                                {/*//    alignSelf: "center",*/}
                                                {/*}}/>*/}
                                            </View>
                                            <HMTextView
                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                text={item.Response}
                                                //type={"bold"}
                                                style={{
                                                    //  textAlign: "center",
                                                    marginTop: moderateScale(6),
                                                    color: Colors.colorDark,
                                                    fontSize: moderateScale(14),


                                                }}/>


                                        </View>

                                    </View>
                                }}
                                //renderItem={this.renderItem}
                                keyExtractor={(item, index) => index.toString()}
                                ListEmptyComponent={() =>
                                    null}
                                //  ItemSeparatorComponent={this.renderSeparator.bind(this)}
                                ListFooterComponent={this.renderFooter.bind(this)}
                                refreshing={this.props.showRefresh}
                                onRefresh={this.handleRefresh.bind(this)}
                                onEndReached={this.handleLoadMore.bind(this)}
                                initialNumToRender={typeExport._Count-1}   onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                            />
                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getData(this.props.page)}/> : null
                            }

                            {/*     <HMModal
                                visibleModal={this.state.visibleModal === 'Modal'}
                                hiddenModal={() => this.hiddenModal()}
                                textInput={this.state["text" + this.state.indexFilter]}
                                SearchFilterFunction={text => this.SearchFilterFunction("array", "text", text, childFilter)}
                                //textInput={this.state.mobile}
                                dataSource={this.state["dataSource" + this.state.indexFilter]}
                                // onChange={() => this.onChangeCondition(index, item)}
                                onChangeItem={this.onChange}
                            />*/}

                            <TouchableOpacity
                                onPress={() => {
                                    this.setState({
                                        visibleModal: true
                                    })
                                }}
                                style={{
                                    position: 'absolute',
                                    bottom: 0,
                                    overflow: 'hidden',
                                    width: moderateScale(48),
                                    height: moderateScale(48),
                                    borderRadius: moderateScale(24),
                                    // padding: moderateScale(4),
                                    margin: moderateScale(5),
                                    borderWidth: moderateScale(1),
                                    borderColor: '#ddd',
                                    borderBottomWidth: 0,
                                    shadowColor: '#000',
                                    shadowOffset: {width: 0, height: moderateScale(.7)},
                                    shadowOpacity: 0.6,
                                    shadowRadius: moderateScale(2),
                                    elevation: moderateScale(1),
                                    // marginLeft: moderateScale(1),
                                    // marginRight: moderateScale(1),
                                    // marginTop: moderateScale(1),
                                    // marginBottom: moderateScale(1),
                                    backgroundColor: Colors.colorSecondPrimary,
                                    alignItems: 'center',
                                    justifyContent: "center"
                                }}>
                                <HMIcon name="md-add" style={{
                                    color: Colors.white,
                                    fontSize: moderateScale(28),
                                    //  padding: moderateScale(4),
                                    alignSelf: "center",
                                }}/>
                            </TouchableOpacity>

                            {this.renderModal()}
                        </View>

                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

    renderItem = ({item, index}) => {
        return <View/>
    }

    checkSelect(item, index) {
        let l = container.state["selectFilter" + index];

        return l && l.id != 0
        // switch (index) {
        //     case 0:
        //
        //         return this.state.Condition.id !== 0
        //
        //     case 1:
        //
        //         return this.state.Operational_Unit.id !== 0
        //
        //     default:
        //
        // }
    }

    SelectNameFilter(item, index) {
        //let {result} = store.getState().reducerSplashSatiaScreen.resultsShahrdar

        let l = this.state["selectFilter" + index]

        return l && l.value ? l.value : item.name
        // switch (index) {
        //     case 0:
        //
        //         return this.state.Condition.value
        //
        //     case 1:
        //
        //         return this.state.Operational_Unit.value
        //
        //     default:
        //
        // }
    }

    renderItemFilter = ({item, index}) => {
        let checkIndex = this.checkSelect(item, index);
        // let {result} = store.getState().reducerSplashSatiaScreen.resultsShahrdar
        let idx = container.state.arraySelected.findIndex(obj => obj.index === index);

        return <View
            onPress={() => {

            }
            }
            style={{
                paddingHorizontal: moderateScale(3),
                backgroundColor: checkIndex ? Colors.colorPrimary : Colors.white,
                borderRadius: moderateScale(4),
                marginHorizontal: moderateScale(2)
            }}
        >
            <View style={[{
                //marginVertical: moderateScale(15),
                height: moderateScale(30),
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'row'
            }]}>
                {/*<HMTextView text={item.name} type={(this.props.position === index) ? "bold" : "normal"}*/}
                {/*style={(this.props.position === index) ? styles.selectedTextStyle : styles.textStyle}/> */}
                {
                    checkIndex ?

                        <View style={{flexDirection: 'row'}}>


                            <TouchableOpacity
                                onPress={() => {
                                    //  let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
                                    let arr = container.state.arraySelected;

                                    if (idx !== -1) {
                                        arr.splice(idx, 1)

                                        container.setState({
                                                arraySelected: arr,
                                                [`selectFilter${index}`]: {
                                                    value: item.name,
                                                    id: item.id,
                                                    type: item.type
                                                },
                                                visibleModal: false,
                                            },

                                            () => {
                                                container.getData(1)
                                            }
                                        )
                                    }
                                    // container.setState({
                                    //         [`selectFilter${index}`]: {
                                    //             value: item.name,
                                    //             id: item.id,
                                    //             type:item.type
                                    //         },
                                    //         visibleModal: false,
                                    //     },
                                    //     () => {
                                    //         let arr = this.state.arraySelected;
                                    //         this.setState({
                                    //                 arraySelected: arr
                                    //             },
                                    //             () => {
                                    //                 container.getData(1)
                                    //             }
                                    //         )
                                    //
                                    //     }
                                    // )

                                }}
                                style={{
                                    alignSelf: 'center',
                                    //  marginHorizontal:moderateScale(6)
                                }}>
                                <HMIcon name={"md-close"} style={{
                                    fontSize: moderateScale(20),
                                    color: '#f2f2f2'
                                }}/>

                            </TouchableOpacity>
                        </View>
                        :
                        null


                }
                {
                    checkIndex ?
                        <View style={{width: moderateScale(6),}}/>

                        :
                        null
                }
                <TouchableOpacity
                    onPress={() => {

                        this.setState({
                                indexFilter: index,
                                typeFilter: item.type,
                                ["dataSource" + index]: item.list
                            },
                            () => {
                                //  this.onShow(item.type == 2 ? 'Operational_Unit' : 'Condition')
                                this.onShow('Modal')

                            })
                    }
                    }

                    style={{alignItems: 'center', flexDirection: 'row'}}
                >

                    <HMTextView text={this.SelectNameFilter(item, index)} type={"bold"}
                                style={{
                                    color: checkIndex ? Colors.white : Colors.gray,
                                    //marginHorizontal: moderateScale(6),
                                    fontSize: moderateScale(14),
                                    textAlign: 'center',

                                }}/>
                    <HMIcon name={"ios-arrow-down"} style={{
                        fontSize: moderateScale(11),
                        color: checkIndex ? '#f2f2f2' : Colors.gray,
                        marginHorizontal: moderateScale(2),
                        marginTop: moderateScale(3)
                    }}/>
                </TouchableOpacity>


            </View>
            {/*<View style={{height:moderateScale(2),width:'100%',backgroundColor:(this.props.position === index) ? '#17bba4' :'transparent'}}/>*/}

        </View>
    }

    /*  renderItems = ({item, index}) => {
          return <DetailsAdapter
              item={item}
              index={index}
              navigation={this.props.navigation}
              props={this.props.route.params}/>;
      }*/
    handleRefresh = () => {
        if (store.getState().reducerSplashSatiaScreen.Connection) {
            this.getData(1)
        } else {
            // ParentScreen.ShowMessageBack(i18n.t('constant.CheckYourInternet'))
        }


        //  this.props.callService(urlListQuestionAndAnswerSatiaScreen, `?type=${this.props.typee}&city=`, TypeGetListQuestionAndAnswerSatiaScreen, 'POST', 1)
    }

    renderFooter() {

        if (this.props.failed === false) {
            return this.props.lazyload_end || this.props.page === 0 ? null :

                <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>


        } else {
            return (
                <HMButton
                    text={i18n.t('constant.retry')}
                    style={styles.buttonModalStyle}
                    onPress={() =>
                        this.getData(this.props.page)
                    }

                />
            );
        }
    }

    handleLoadMore() {
        if (this.props.results.length > 0 && this.props.lazyload_end !== true && this.props.showLoading !== true && store.getState().reducerSplashSatiaScreen.Connection) {
            // this.props.callService(urlListQuestionAndAnswerSatiaScreen, `?type=${this.props.typee}&Condition=`, TypeGetListQuestionAndAnswerSatiaScreen, 'POST', this.props.page)
            if (this.props.page === 0)
                this.getData(1)
            else
                this.getData(this.props.page)
        }
    }

    onChange(index, data) {

        let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
        let arr = container.state.arraySelected;

        if (idx !== -1) {
            arr.splice(idx, 1)

            container.setState({
                    arraySelected: arr
                },

                () => {
                    //  container.state.arraySelected.slice(container.state.indexFilter, 1)
                    container.state.arraySelected.push({
                        index: container.state.indexFilter,
                        data: data,
                        id: data.id,
                        value: data.name,
                        type: container.state.typeFilter
                    })
                }
            )

        } else {
            container.state.arraySelected.push({
                index: container.state.indexFilter,
                data: data,
                id: data.id,
                value: data.name,
                type: container.state.typeFilter
            })
            // arr = [...newState.listFilter, {...action.data}]
            // newState.listFilter = arr
        }

        let l = container.state.indexFilter

        container.setState({
                [`selectFilter${l}`]: {value: data.name, id: data.id, type: container.state.typeFilter},
                //indexFilterCondition: index,
                visibleModal: false,
            },
            () => {
                container.getData(1)
            }
        )
    }


    hiddenModal() {
        container.setState({
                visibleModal: false
            },
            () => {
            })
    }

    onShow(data) {
        container.setState({
            visibleModal: data,

        });
    }

    SearchFilterFunction(data, name, text, childFilter) {
        // let dataSource = "dataSource" + data
        // const newData = this.state[data].filter(function (item) {
        //     const itemData = item.name ? item.name.toUpperCase() : item.sleep_number.toUpperCase()
        //     const textData = text.toUpperCase()
        //     return itemData.indexOf(textData) > -1
        // })
        // this.setState({
        //         [dataSource]: newData,
        //         //dataSource: newData,
        //         [name]: text
        //     },
        //     () => {
        //     })
        //

        let dataSource = "dataSource" + this.state.indexFilter;
        name = name + this.state.indexFilter;
        const newData = childFilter.list.filter(function (item) {
            const itemData = item.name ? item.name.toUpperCase() : item.sleep_number.toUpperCase()
            const textData = text.toUpperCase()
            return itemData.indexOf(textData) > -1
        })
        this.setState({
                [dataSource]: newData,
                //dataSource: newData,
                [name]: text
            },
            () => {
            })
    }


    renderModal(data) {

        return (
            <HMModal
                isVisible={this.state.visibleModal}
                backdropColor={Colors.gray}
                backdropOpacity={0.8}
                animationIn="zoomInDown"
                animationOut="zoomOutUp"
                animationInTiming={600}
                animationOutTiming={600}
                backdropTransitionInTiming={600}
                backdropTransitionOutTiming={600}
                //style={{height: '60%'}}
                onBackdropPress={() => this.hiddenModal()}
                onBackButtonPress={() => this.hiddenModal()}
            >

                <View style={{
                    width: '98%',
                    //  height: "90%",
                    padding: moderateScale(16),
                    backgroundColor: Colors.white,
                    border: moderateScale(4)
                }}>

                    <ScrollView
                        style={{
                            width: '100%'

                        }}
                        ref={scroll => this._scroll = scroll}
                        keyboardShouldPersistTaps="handled"
                    >


                        {/*<HMSelectInput loading={false} value={i18n.t('constant.SelectItem')}*/}
                        {/*//text={i18n.t('constant.DeviceType')}*/}
                        {/*text={"واحد"}*/}
                        {/*options={[{*/}
                        {/*value: 'پشتیبانی فنی', label: 'پشتیبانی فنی',*/}
                        {/*}]}/>*/}

                        {/*<HMSelectInput loading={false} value={i18n.t('constant.SelectItem')}*/}
                        {/*//text={i18n.t('constant.DeviceType')}*/}
                        {/*text={"سرویس"}*/}
                        {/*options={[*/}
                        {/*{*/}
                        {/*value: 'اینترنت ADSL', label: 'اینترنت ADSL',*/}
                        {/*}, {*/}
                        {/*value: 'اینترنت WIRELESS', label: 'اینترنت WIRELESS',*/}
                        {/*},*/}
                        {/*]}/>*/}
                        {/*<HMSelectInput loading={false} value={i18n.t('constant.SelectItem')}*/}
                        {/*//text={i18n.t('constant.DeviceType')}*/}
                        {/*text={"اولویت"}*/}
                        {/*options={[*/}
                        {/*{*/}
                        {/*value: 'کم', label: 'کم',*/}
                        {/*}, {*/}
                        {/*value: 'عادی', label: 'عادی',*/}
                        {/*}, {*/}
                        {/*value: 'بالا', label: 'بالا',*/}
                        {/*}, {*/}
                        {/*value: 'بسیار بالا', label: 'بسیار بالا',*/}
                        {/*},*/}
                        {/*]}/>*/}
                        {/*<HMTextInputEfects*/}
                        {/*_ref={scroll => this["inputtitle"] = scroll}*/}

                        {/*refName={"title"}*/}

                        {/*type={"CostumeFumi"}*/}
                        {/*value={this.state.title}*/}

                        {/*label={i18n.t('constant.title')}*/}
                        {/*onChangeText={text => this.setState({*/}
                        {/*title: text*/}
                        {/*})}*/}
                        {/*iconClass={FontAwesomeIcon}*/}
                        {/*iconName={'phone'}*/}
                        {/*//keyboardType={'number-pad'}*/}
                        {/*// _scroll={this._scroll}*/}

                        {/*// secureTextEntry={true}*/}
                        {/*onSubmitEditing={() => this._focusNextField("inputDescription")}*/}
                        {/*containerStyle={{}}*/}
                        {/*containerInputStyle={{*/}
                        {/*borderWidth: moderateScale(1),*/}

                        {/*borderRadius: moderateScale(10),*/}
                        {/*// overflow: 'hidden',*/}
                        {/*marginVertical: moderateScale(4)*/}
                        {/*}}*/}
                        {/*border={true}*/}

                        {/*/>*/}
                        <HMTextInputEfects
                            _ref={scroll => this["inputDescription"] = scroll}

                            refName={"Description"}

                            type={"CostumeFumi"}
                            value={this.state.Description}

                            // label={i18n.t('constant.Description')}
                            label={"پاسخ"}
                            onChangeText={text => this.setState({
                                Description: text
                            })}
                            iconClass={FontAwesomeIcon}
                            iconName={'phone'}
                            //keyboardType={'number-pad'}
                            // _scroll={this._scroll}

                            // secureTextEntry={true}
                            // onSubmitEditing={() => {}}
                            //  containerStyle={{}}
                            containerInputStyle={{
                                borderWidth: moderateScale(1),

                                borderRadius: moderateScale(10),
                                // overflow: 'hidden',
                                marginVertical: moderateScale(4)
                            }}
                            border={true}
                            multiline={true}

                            height={moderateScale(80)}
                            requireField
                        />
                        <View style={{
                            flexDirection: 'row', width: '92%', justifyContent: 'center',
                            //  backgroundColor: 'red',
                            marginTop: moderateScale(10),
                            marginBottom: moderateScale(4), alignSelf: 'center',
                        }}>
                            <TouchableOpacity
                                onPress={() => {
                                    this.setData(1)

                                }}
                                style={{
                                    flex: .33,
                                    // width: '92%',
                                    height: moderateScale(42),
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: Colors.green,
                                    borderRadius: moderateScale(6),


                                }}>

                                <HMTextView
                                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                    text={i18n.t('constant.Registration')}
                                    type={"bold"}
                                    style={{
                                        fontSize: moderateScale(14),
                                        marginVertical: moderateScale(2),
                                        // marginHorizontal: moderateScale(4),
                                        color: Colors.white
                                    }}/>
                            </TouchableOpacity>
                            <TouchableOpacity
                                onPress={() => {
                                    this.setData(2)

                                }}
                                style={{
                                    flex: .33,
                                    // width: '92%',
                                    height: moderateScale(42),
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: Colors.yellow,
                                    borderRadius: moderateScale(6),
                                    marginHorizontal: moderateScale(2)


                                }}>

                                <HMTextView
                                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                    // text={i18n.t('constant.Registration')}
                                    text={"ثبت و بستن تیکت"}
                                    type={"bold"}
                                    style={{
                                        fontSize: moderateScale(14),
                                        marginVertical: moderateScale(2),
                                        //     marginHorizontal: moderateScale(4),
                                        color: Colors.white
                                    }}/>
                            </TouchableOpacity>
                            <TouchableOpacity
                                onPress={() => {
                                    this.setData(3)
                                }}
                                style={{
                                    flex: .33,
                                    // width: '92%',
                                    height: moderateScale(42),
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: Colors.red,
                                    borderRadius: moderateScale(6),


                                }}>

                                <HMTextView
                                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                    text={"بستن تیکت"}
                                    type={"bold"}
                                    style={{
                                        fontSize: moderateScale(14),
                                        marginVertical: moderateScale(2),
                                        //  marginHorizontal: moderateScale(4),
                                        color: Colors.white
                                    }}/>
                            </TouchableOpacity>

                        </View>
                    </ScrollView>
                    {
                        this.props.isLoadingSet ?
                            <DialogLoadingCustomize/>
                            : null
                    }

                </View>
            </HMModal>
        );
    }

    async setData(type) {
        let {item, data} = this.props.route.params

        let after = "0000-00-00";
        //   this.props.callService(urlListMessageOperatorSatiaScreen, `?type=${this.props.typee}&Condition=`, TypeGetListMessageOperatorSatiaScreen, 'POST',page,this.props.item_count)
        // this.props.callService(typeExport.urlListMessageOperatorSatiaScreen, `?lang=${i18n.locale}&token=${this.props.DataSplashScreen.token}`, typeExport.TypeGetListMessageOperatorSatiaScreen, 'POST', page, 10)
        /*  let paramss = {
              "id": 1,
              "lang": i18n.locale,
              "imei": 0,
              "page": page,
               "after": "0000-00-00"
          };
          this.props.callService(this.props.route.params.item.link_url, paramss, typeExport.TypeGetListMessageOperatorSatiaScreen, _GET, page, 10)
  */

        let paramss = {
            "_operation": typeExport._Fire,

            "mode": typeExport._GetDashboard,
            "lang": i18n.locale,
            "_session": store.getState().reducerSplashSatiaScreen.token,
            "serialTicket": item.Serial,
            "answerTicket": this.state.Description,
            "typeResponse": type,
        };
        if (store.getState().reducerSplashSatiaScreen.Connection) {

            this.props.callService(typeExport._baseUrlSatia + "support/questionAnswer", paramss, typeExport.TypeSetListQuestionAndAnswerSatiaScreen, typeExport._POST, 1, 10, null, this.getData)

        } else {
            // let data = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListServiceHistorySatia + item.type)
            // let listFilter = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListServiceHistorySatiaFilter + item.type)
            // store.dispatch(serviceActionListFilter(listFilter))
            // if (data != null)
            //     store.dispatch(serviceActionSuccess(data, 0))
            // else
            //     store.dispatch(serviceActionSuccess([], 0))

            store.dispatch(serviceActionError('not connection', 1))
        }

    }

    _onRef = (property, view) => {
        this[property] = view
    }

    _focusNextField(nextField) {
        this[nextField].focus()
        this[nextField].measureLayout(
            ReactNative.findNodeHandle(this._scroll),
            (x, y) => {
                this._scroll.scrollTo({x: 0, y: y - moderateScale(40), animated: true});
            }
        );
    }
}
